<template>
  <section class="app-sidebar" >
    <nav class="sidebar sidebar-offcanvas" id="sidebar" style="z-index: 1001;">
      <ul class="nav" v-if="userprofile.type == 2">
        <li class="nav-item" v-on:click="collapseAll">
          <router-link class="nav-link" to="/">
            <i class="ti-home menu-icon"></i>
            <span class="menu-title">Job Tickets</span>
          </router-link>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'sites'">
            <i class="menu-icon"><font-awesome-icon icon="building"/></i>
            <span class="menu-title">Sites</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="sites">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/sites">PoP Sites</router-link>
              </li>
              <li class="nav-item" v-if="sitesLoaded">
                <a class="nav-link" @click="getUserCheckins()">Site Check-In</a>
                <siteCheckinModal modalID="siteCheckinModal" :checkedInSite ="checkoutsActive ? getSite(checkoutList[0].siteid) : null"/>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'equipment'">
            <i class="menu-icon"><font-awesome-icon icon="server"/></i>
            <span class="menu-title">Equipment</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="equipment">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/equipment/inventory">Spare Parts Inventory</router-link>
              </li>           
              <li class="nav-item">
                <router-link class="nav-link" to="/equipment">Equipment</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item" v-on:click="collapseAll" >
          <router-link class="nav-link" to="/general-pages/customer-faq">
            <i class="menu-icon"><font-awesome-icon icon="building"/></i>
            <span class="menu-title">FAQ & Knowledge Base</span>          
          </router-link>
        </li>
        <li class="nav-item cursor-pointer text-center d-flex d-md-none">
          <a :href="`tel:1300837638`" class="nav-link">
            <button type="button" class="btn btn-inverse-primary btn-fw"><i class="mx-0 mr-1">
              <font-awesome-icon icon="phone"></font-awesome-icon>
            </i> 1300 837 638
            </button>
          </a>
        </li>
      </ul>









      <ul  class="nav" v-else>
        <li class="nav-item" v-on:click="collapseAll">
          <router-link class="nav-link" to="/">
            <i class="ti-home menu-icon"></i>
            <span class="menu-title">Dashboard</span>
          </router-link>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'services'">
            <i class="menu-icon"><font-awesome-icon icon="ethernet"/></i>
            <span class="menu-title">Services</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="services">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/services">All Services</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/services/unmanaged">Unmanaged Services ({{unmanagedservicesCount}})</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/services/managed">Managed Services ({{managedservicesCount}})</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/services/vpls-networks">VPLS Services ({{vplsServicesCount}})</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/services/internet">Internet Services ({{internetServicesCount}})</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/services/l3vpn">L3VPN Services ({{l3vpnServicesCount}})</router-link>
              </li>
              <li class="nav-item" v-if="userprofile.type == 1">
                <router-link class="nav-link" to="/services/thirdparty">Third-Party Services ({{thirdPartyServicesCount}})</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/services/service-notifications">Notifications</router-link>
              </li>
              <li class="nav-item" v-if="userprofile.type == 1">
                <router-link class="nav-link" to="/services/links">Service Links</router-link>
              </li>
              <li class="nav-item" v-if="userprofile.type === 1 && servicesLoaded && sitesLoaded">
                <a class="nav-link" @click="$bvModal.show('newSidebarService')">New Service</a>
                <newServiceModal modalID="newSidebarService" />
              </li>
              <li class="nav-item" v-if="userprofile.type === 1">
                <router-link class="nav-link" to="/services/deprovision">Deprovision Service</router-link>
              </li>
              
              <!-- <li class="nav-item">
                <router-link class="nav-link" to="/">Cloud Connections</router-link>
              </li> -->
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'colocation'">
            <i class="menu-icon"><font-awesome-icon icon="server"></font-awesome-icon></i>
            <span class="menu-title">Co-location</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="colocation">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/colocation/rackspaces">Rack Spaces</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/colocation/crossconnects">Cross-Connects</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item" v-on:click="collapseAll" v-if="userprofile.type > 3">
          <router-link class="nav-link" to="/sites">
            <i class="menu-icon"><font-awesome-icon icon="building"/></i>
            <span class="menu-title">Sites</span>
          </router-link>
        </li>
        <li class="nav-item cursor-pointer" v-else-if="userprofile.type === 1 || userprofile.type === 3">
          <span class="nav-link" v-b-toggle="'sites'">
            <i class="menu-icon"><font-awesome-icon icon="building"/></i>
            <span class="menu-title">Sites</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="sites">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/sites">All Sites</router-link>
              </li>
              <li class="nav-item" v-if="userprofile.type === 1">
                <a class="nav-link" @click="$bvModal.show('newSiteModal')">Add New Site</a>
                <sitecreationform modalID="newSiteModal" />
              </li>
              <li class="nav-item" v-if="userprofile.type === 1 && sitesLoaded">
                <a class="nav-link" @click="$bvModal.show('newSiteAccess')">Site Access Request</a>
                <siteAccessModal modalID="newSiteAccess" />
              </li>
              <li class="nav-item" v-if="userprofile.type === 1 && sitesLoaded">
                <a class="nav-link" @click="getUserCheckins()">Site Check-In</a>
                <siteCheckinModal modalID="siteCheckinModal" :checkedInSite ="checkoutsActive ? getSite(checkoutList[0].siteid) : null"/>
              </li>
              <li class="nav-item" v-if="userprofile.type < 4 && sitesLoaded">
                <router-link class="nav-link" to="/site-inspection/default">Site Inspection Checksheet</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer" v-if="userprofile.type == 1 || userprofile.type == 3">
          <span class="nav-link" v-b-toggle="'equipment'">
            <i class="menu-icon"><font-awesome-icon icon="server"/></i>
            <span class="menu-title">Equipment</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="equipment">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/equipment">Equipment</router-link>
              </li>

              <li class="nav-item">
                <router-link class="nav-link" to="/equipment/inventory">Spare Parts Inventory</router-link>
              </li>   
              <li class="nav-item">
                <a class="nav-link" @click="$bvModal.show('updateEquipment')">Update Equipment</a>
                <updateEquipmentModal modalID="updateEquipment" @EventCreated="(eventID) => newEvent(eventID)" />
              </li>  
              <li class="nav-item">
                <router-link class="nav-link" to="/equipment/zabbix-triggers">Muted Zabbix Notifications</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/general-pages/technician-job-creator">Create Technician Job</router-link>
              </li> 
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item" v-if="userprofile.type == 1 || userprofile.type == 3">
          <router-link class="nav-link" to="/jobs">
            <i class="menu-icon fa fa-cloud-download"></i>
            <span class="menu-title">AWX Jobs</span>
          </router-link>
        </li>
        <li class="nav-item cursor-pointer" v-if="userprofile.type == 1">
          <span class="nav-link" v-b-toggle="'customers'">
            <i class="menu-icon fa fa-university"></i>
            <span class="menu-title">Customers</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="customers">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link"  to="/customers">All Customers</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link"  to="/customers/links">Customer Links</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item" v-on:click="collapseAll">
          <router-link class="nav-link" to="/contacts">
            <i class="menu-icon fa fa-id-badge"></i>
            <span class="menu-title">Contacts</span>
          </router-link>
        </li>
        <li class="nav-item" v-on:click="collapseAll">
          <router-link class="nav-link" to="/functions/state-map">
            <i class="menu-icon fa fa-map"></i>
            <span v-if="userprofile.type == 1" class="menu-title">Network Map</span>
            <span v-else class="menu-title">Network Alert Map</span>
          </router-link>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'event-dropdown'">
            <i class="menu-icon fa fa-calendar"></i>
            <span class="menu-title">Events</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="event-dropdown">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/events/scheduled-events">Scheduled Events ({{scheduledevents.length}})</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/events">Network Outages ({{problems.length}})</router-link>
              </li>
              <li class="nav-item" v-if="userprofile.type === 1">
                <a class="nav-link" @click="$bvModal.show('newSidebarEvent')">New Event</a>
                <newEventModal modalID="newSidebarEvent" @EventCreated="(eventID) => newEvent(eventID)" />
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/events/past-events">Past Outages</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'reports'">
            <i class="menu-icon fa fa-book" ></i>
            <span class="menu-title">Reports</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="reports">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/documentation/sla-reports">SLA Reports</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/documentation/usage-reports">Usage Reports</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/documentation/service-report">Service Report</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/documentation/changeman-reports">Change Management</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/documentation/invoices">Invoices</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/documentation/logs">API Logs</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/uploads/generaluploads">General Uploads</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item"  v-on:click="collapseAll">
            <router-link class="nav-link" to="/documentation/purchaseorders">
              <i class="ti-pencil-alt menu-icon"></i>
              Purchase Orders
            </router-link>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'support-dropdown'">
            <i class="menu-icon"><font-awesome-icon icon="life-ring"/></i>
            <span class="menu-title">Support</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="support-dropdown">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item" v-if="userprofile.chameleon !== 2">
                <router-link class="nav-link" to="/tickets">Tickets</router-link>
              </li>
              <li class="nav-item" v-if="userprofile.chameleon !== 2">
                <a class="nav-link" @click="$bvModal.show('newSidebarTicket')">New Ticket</a>
                <newTicketModal modalID="newSidebarTicket" @TicketCreated="(ticketID) => newTicket(ticketID)" />
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/general-pages/customer-faq">FAQ & Knowledgebase</router-link>
              </li>
              <li class="nav-item">
                <router-link class="nav-link" to="/general-pages/release-notes">Portal Release Notes</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer">
          <span class="nav-link" v-b-toggle="'admin'">
            <i class="ti-clipboard menu-icon"></i>
            <span class="menu-title">Administration</span>
            <i class="menu-arrow"></i>
          </span>
          <b-collapse accordion="sidebar-accordion" id="admin">
            <ul class="nav flex-column sub-menu">
              <li class="nav-item">
                <router-link class="nav-link" to="/users">Users</router-link>
              </li>
              <li v-if="userprofile.companyAdmin" class="nav-item">
                <router-link class="nav-link" to="/">Company Settings</router-link>
              </li>
            </ul>
          </b-collapse>
        </li>
        <li class="nav-item cursor-pointer text-center d-flex d-md-none">
          <a :href="`tel:1300837638`" class="nav-link">
            <button type="button" class="btn btn-inverse-primary btn-fw"><i class="mx-0 mr-1">
              <font-awesome-icon icon="phone"></font-awesome-icon>
            </i> 1300 837 638
            </button>
          </a>
        </li>
      </ul>
    </nav>
  </section>
</template>

<script>

import newTicketModal from "@/pages/tickets/components/newTicketModal";
import newEventModal from "@/pages/events/components/newEventModal";
import newServiceModal from "@/pages/services/components/newServiceModal";
import sitecreationform from "@/components/vernet/sitecreationform";
import siteAccessModal from "@/pages/sites/components/siteAccessModal";
import updateEquipmentModal from "@/pages/equipment/components/updateEquipmentModal";
import siteCheckinModal from "@/pages/sites/components/siteCheckinModal";

export default {
  name: "sidebar",
  components: {
    newTicketModal,
    newEventModal,
    newServiceModal,
    sitecreationform,
    siteAccessModal,
    updateEquipmentModal,
    siteCheckinModal,
   },

  computed: {
    userprofile () {
      return this.$store.getters.getProfile;
    },
    customerprofile () {
      return this.$store.getters.getMyCustomerProfile;
    },
    scheduledevents() {
      try {
        var eventsList = this.$store.getters.getFutureOngoingEventsListByType(1).concat(this.$store.getters.getRecentEventsByType(1)).concat(this.$store.getters.getFutureOngoingEventsListByType(2)).concat(this.$store.getters.getRecentEventsByType(2))
        return eventsList
      } catch (error) {
        return this.items;
      }
    },
    problems() {
      try {
        var eventsList = this.$store.getters.getFutureOngoingEventsListByType(3).concat(this.$store.getters.getRecentEventsByType(3));
        return eventsList
      } catch (error) {
        return this.items;
      }
    },
    unmanagedservicesCount(){
      try {
        return this.$store.getters.getServicesListByType('A').length
      } catch (error) {
        return this.items;
      }
    },
    managedservicesCount(){
      try {
        return this.$store.getters.getServicesListByType('B').length + this.$store.getters.getServicesListByType('C').length + this.$store.getters.getServicesListByType('D').length + this.$store.getters.getServicesListByType('E').length
      } catch (error) {
        return this.items;
      }
    },
    vplsServicesCount(){
      try {
        return this.$store.getters.getServicesListByType('F').length + this.$store.getters.getServicesListByType('W').length
      } catch (error) {
        return this.items;
      }
    },
    internetServicesCount(){
      try {
        return this.$store.getters.getServicesListByType('H').length + this.$store.getters.getServicesListByType('W').length
      } catch (error) {
        return this.items;
      }
    },
    l3vpnServicesCount(){
      try {
        return this.$store.getters.getServicesListByType('G').length
      } catch (error) {
        return this.items;
      }
    },
    thirdPartyServicesCount(){
      try {
        return this.$store.getters.getAllThirdPartyServices.length
      } catch (error) {
        return this.items;
      }
    },
    servicesLoaded(){
      try {
        return this.$store.getters.isServicesListLoaded
      } catch (error) {
        return false
      }
    },
    sitesLoaded(){
      try {
        return this.$store.getters.isSitesListLoaded
      } catch (error) {
        return false
      }
    }
  },
  data() {
    return {
      collapses: [{ show: false }, { show: false }, { show: false }],
      items: [],
      checkoutsActive: false,
      checkoutList: []
    };
  },
  methods: {
    getSite(siteid){
        return this.$store.getters.getSite(siteid)
    },
    getUserCheckins() {
      let userCheckins = this.$store.getters.getUserCheckins(this.userprofile.userid).filter(thisCheckin => thisCheckin.checkouttime == null)
      if(userCheckins.length > 0){
        this.checkoutList = userCheckins
        this.checkoutsActive = true
      } else {
        this.checkoutList = []
        this.checkoutsActive = false
      }

      this.$bvModal.show('siteCheckinModal')
    },
    collapseAll() {
      var exp_elm = document.getElementsByClassName("show");
      if (exp_elm.length > 0) {
        var elm_id = exp_elm[0].id;
        this.$root.$emit("bv::toggle::collapse", elm_id);
      }
    },
    revealAll() {
      var exp_elm = document.getElementsByClassName("show");
      if (exp_elm.length > 0) {
        var elm_id = exp_elm[0].id;
        this.$root.$emit("bv::toggle::show", elm_id);
      }
    },
    newTicket(ticketID) {
      this.$router.push('/ticket/'+ticketID)
      this.openTicket(ticketID)
    },
  },
  mounted() {
    const body = document.querySelector("body");
    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll(".sidebar .nav-item").forEach(function(el) {
      el.addEventListener("mouseover", function() {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function() {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  },
  watch: {
    $route() {
      if(document.querySelector("#sidebar").classList.contains("active")) { document.querySelector("#sidebar").classList.toggle("active"); }
    }
  }
};
</script>
